'use strict';

var base = require('base/product/base');
var productZoom = require('./productZoom');
var sfraBase = require('./sfraBase');

const PRIMARY_CAROUSEL_CLASS = '.pdp-main-carousel';
const THUMB_CAROUSEL_CLASS = '.anchor-menu-thumbs-slider';

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves item list name to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getItemListName() {
    return $('.ecc-item-list-name').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, _that) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (response.error && response.error.errorType === 'customerExp') {
        $('.js-customer-experience-error').text(response.message);
        $(_that).addClass('disabled');
    } else {
        $('.js-customer-experience-error').text('');

        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

function addToCart() {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var itemListName;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = base.getPidValue($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        addToCartUrl = getAddToCartUrl();
        itemListName = getItemListName();

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: base.getQuantitySelected($(this)),
            itemListName: itemListName
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        var _that = this;

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data, _that);
                    $('body').trigger('product:afterAddToCart', data);
                    if (data.ecc_add_to_cart && window.dataLayer) {
                        window.dataLayer.push(data.ecc_add_to_cart);
                    }
                    $.spinner().stop();
                    base.miniCartReportingUrl(data.reportingURL);

                    if (!data.error) {
                        $('.minicart').trigger('focusin', [true, true]);

                        setTimeout(function () {
                            $('.minicart').trigger('mouseleave', [true]);
                        }, 5000);
                }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $productContainer.find(`.${attr.id}.attribute-label`).text(`${attr.displayName}: ${attr.displayValue}`);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // VML-32: Pulls from preference config
    var attrsWithSwatches = $productContainer.find('[data-swatchable-attrs]').data('swatchableAttrs') || ['colors', 'patterns'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            sfraBase.processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    var isBackorder = false;

    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += `<li>
                    <div class="availability__message">
                        ${message}${response.product.availability.inStockDate ? ': ' + response.resources.info_estimatedinstock + ' <span class="availability__in-stock-date">' + response.product.availability.inStockDate + '</span>' : ''}
                    </div>
                </li>
                `
            if (message === $('div.availability').data('backOrderMsg')) {
                isBackorder = true;
            }
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources,
        isBackorder: isBackorder
    });
}

/**
 * Initialize arrows and controls again on new images 
 * */
function initializeShowMoreControls() {   
    $('.show-more-images-up-arrow').addClass('show-more-images-arrow-disabled');
    $('.show-more-images-down-arrow').removeClass('show-more-images-arrow-disabled');
    $('.show-more-images-up-arrow').attr('data-group-to-show', 0);
    $('.show-more-images-down-arrow').attr('data-group-to-show', 1);
    if (!$('.show-more-images').hasClass('d-lg-flex')) {
        $('.show-more-images').addClass('d-lg-flex');
    }
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} carouselClass - Selector for $carousel
 * @param {*} zoomImageObject - (optional) Object containing array of hi-res zoom image URLs
 */
function createCarousel(imgs, $productContainer, carouselClass, zoomImageObject) {
    var $carousel = $productContainer.find(carouselClass);
    if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
    }
    var maxNumberOfImages = parseInt($('#maxNumberOfImages').val());
    var totalImageLength = imgs.length;
    var imgClass = $carousel.find('img').attr('class');
    var imgParentClass = $carousel.find('img').parents().attr('class');
    $carousel.empty();
    for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (totalImageLength > maxNumberOfImages) {
            // Hard Code the 'carousel-item' class because image-group classes and display classes need to be assigned dynamically 
            if (i < maxNumberOfImages) {
                imgParentClass = 'carousel-item ' + 'image-group-0';
            } else {
                imgParentClass = 'carousel-item ' + 'image-group-1 d-lg-none';
            }
            if (parseInt(i / maxNumberOfImages) > 0) {
                imgParentClass += ' d-lg-none';
            }
            initializeShowMoreControls();
        }
        else {
            // Within the image limit, hide controls
            $('.show-more-images').removeClass('d-lg-flex');
        }
        var $carouselItem = $(`<div class="${imgParentClass}">
            <img src="${img.url}" class="${imgClass}" alt="${img.alt} image number ${(i + 1).toString()}" title="${img.title}" 
                loading="${i > 0 ? 'lazy' : 'auto'}" data-slick-index="${i}" data-zoom-url="${zoomImageObject ? zoomImageObject['hi-res'][i].url : '' }" itemprop="image" />
            ${zoomImageObject ? '<div class="zoom-icon"></div>' : ''}
            </div>`);
        if (carouselClass === THUMB_CAROUSEL_CLASS) {
            $carousel.append($('<div class="thumb-container"/>').html($carouselItem));
        } else {
            $carousel.append($carouselItem);
        }
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVariant;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        $productContainer.find('.product-name').text(response.product.masterName);
        $productContainer.attr('data-pid', response.product.id);
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update images
    var primaryImageUrls = response.product.images.large;
    var thumbImageUrls = response.product.images.small;
    var zoomImageUrls = response.product.zoomImages;
    createCarousel(primaryImageUrls, $productContainer, PRIMARY_CAROUSEL_CLASS, zoomImageUrls);
    createCarousel(thumbImageUrls, $productContainer, THUMB_CAROUSEL_CLASS);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(sfraBase.getAttributesHtml(response.product.attributes));
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent(".bonus-product-item").length <= 0) {
        var maxQty = quantities.length < 100 ? quantities.length : "99";
        var selectedQty;
        var url;

        quantities.forEach(function (quantity) {
            if (quantity.selected) {
                selectedQty = quantity.value;
                url = quantity.url;
            }
        });

        var $qtySelector = sfraBase.getQuantitySelector($productContainer);

        $qtySelector.data("max-qty", maxQty);
        $qtySelector.data("url", url);
        $qtySelector.val(selectedQty);

        var priceSelector = $(".cart-and-ipay .prices .price .sales .value", $productContainer).length
            ? $(".cart-and-ipay .prices .price .sales .value", $productContainer)
            : $(".cart-and-ipay .prices .price .sales .value");
        var price = Math.round($(priceSelector[0]).text().replace(/[^0-9.-]+/g, ""));
        var finalPrice = price * selectedQty;

        priceSelector.text("$" + finalPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                // Reset Hidden Images after variation selection
                // They will be corrected in createCarousel() function dynamically
                $('.pdp-main-carousel .carousel-item').removeClass('d-lg-none');
                handleVariantResponse(data, $productContainer);
                sfraBase.updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer }
                );
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Fires on swatchable attribute select (e.g. color, pattern)
 * Extended to include all swatchable attributes
 */
function colorAttribute() {
    $(document).on('click', '.swatchable-attribute-container button', function (e) {
        e.preventDefault();

        if ($(this).attr('disabled') || $(this).find('.unselectable').length > 0) {
            return;
        }
        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }

        var $sizeSelect = $productContainer.find('.select-size, .select-secondary-attr');
        if ($sizeSelect.length > 0) {
            $sizeSelect.val($sizeSelect.find('option:first').val());
        }

        attributeSelect($(this).attr('data-url'), $productContainer);
    });
}

/**
 * Fires on select attribute change
 * Need this to use our custom attributeSelect function
 */
function selectAttribute() {
    $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        attributeSelect(e.currentTarget.value, $productContainer);
    });
}

/**
 * Overrides base availability
 */
function availability() {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            attributeSelect(
                $(e.currentTarget).find('option:selected').data('url'),
                $productContainer
            );
        }
    });
}

function productZoomListeners() {
    $('body').on('product:afterAttributeSelect', function () {
        $('#productZoomModal').remove();
        productZoom.createProductZoomModal();
    });
}

var exportDetails = $.extend({}, base, {
    availability: availability,
    addToCart: addToCart,
    colorAttribute: colorAttribute,
    selectAttribute: selectAttribute,
    attributeSelect: attributeSelect,
    productZoomListeners: productZoomListeners,
    PRIMARY_CAROUSEL_CLASS: PRIMARY_CAROUSEL_CLASS,
    THUMB_CAROUSEL_CLASS: THUMB_CAROUSEL_CLASS
});

productZoom.initProductZoom();

module.exports = exportDetails;

